export default "__VITE_PUBLIC_ASSET__ebf08bb3__"